export default {
	methods: {
		register(data) {
			return this.post('/register', data).then((data) => {
				return data.uid;
			});
		},
		verifyUid(uid) {
			return this.post('/verify-uid', { uid: uid }).then((data) => {
				return true;
			});
		}
	}
}
